import { TFunction } from 'i18next';

import { i18n } from '@aqx-core/common/i18n';

/**
 * Safe translation helper that provides fallback behavior.
 * This function creates a safe translation function that handles chart context properly.
 * It tries the passed translation function first, then falls back to i18n.t with explicit error handling.
 * This replaces the complex safe translation utilities with a simpler approach.
 */
export const safeT = (t?: TFunction) => {
  return (key: string): string => {
    // First try the passed translation function
    if (t) {
      try {
        return t(key);
      } catch {}
    }

    // Fall back to i18n.t with explicit language check
    try {
      return i18n.t(key);
    } catch {
      return key;
    }
  };
};

/**
 * Simple safe translation helper that returns the translation function or i18n.t as fallback.
 * Use this for functions that need default parameter behavior.
 */
export const getSafeT = (t?: TFunction): TFunction => {
  return t || i18n.t;
};
